module.exports = __webpack_public_path__ + "static/img/banner-2.e9d98573.png";